
import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminMenu from '../components/AdminMenu';

function AdminPanel({ user }) {
    return (
        <div className="d-flex" style={{ minHeight: '100vh' }}>
            <AdminMenu />
            <div className="flex-grow-1 pt-5">
                <Outlet />
            </div>
        </div>
    );
}

export default AdminPanel;
